export default __webpack_public_path__ + "images/e532745e7b7340bfc3c63adb6fd61bcb-7316_NIYT_home_header_mobile_659x494.jpg";